module.exports = __webpack_public_path__ + "static/img/pexels-photo-5632402@2x.5cdcdcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/productOperation/innovativeTechnology/pexels-photo-5632402@2x.png
// module id = nG2o
// module chunks = 0